'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import PageFooterForLayout from './PageFooterForLayout';
import usePageLayoutName from './usePageLayoutName';
const PageFooter = () => {
  const $ = _c(2);
  const layoutName = usePageLayoutName();
  let t0;
  if ($[0] !== layoutName) {
    t0 = <PageFooterForLayout layoutName={layoutName} />;
    $[0] = layoutName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default memo(PageFooter);